




































import { defineComponent, reactive, toRefs, watch } from '@vue/composition-api'
import OriginView from './originView.vue'

export default defineComponent({
  name: 'Views',
  components: {
    OriginView
  },
  props: {
    appViews: {
      default: []
    }
  },
  setup(props) {
    const state = reactive({
      currentIndex: 0,
      originViewShow: false
    })

    const prev = () => {
      if (state.currentIndex > 0) {
        state.currentIndex--
      }
    }
    const next = () => {
      if (state.currentIndex < props.appViews.length - 1) {
        state.currentIndex++
      }
    }
    watch(
      () => state.originViewShow,
      () => {
        if (state.originViewShow) {
          const scrollTop = document.body.scrollTop
          document.body.style.overflow = 'hidden'
          document.body.scrollTop = scrollTop
        } else {
          document.body.style.overflow = ''
        }
      }
    )

    return {
      ...toRefs(state),
      prev,
      next
    }
  }
})
